import axios from '../Backend';

// export const checkActiveCalls = async () => {
//     try {
//         await axios.get('/call/checkActiveCalls');
//     } catch (e) {
//         console.log('checkActiveCalls fail')
//         console.log(JSON.stringify(e))
//     }

// }

export const fetchDialListUpdatedCrmData = async (_id) => {
    try {
        if (!_id) return console.log('fetchDialListUpdatedCrmData :: some data is missed')
        axios.put('/diallist/fetchDialListUpdatedCrmData', { _id });
    } catch (e) {
        console.log('fetchDialListUpdatedCrmData :: Error')
        console.log(JSON.stringify(e))
    }
}